import { Flame, Hourglass, Inbox, ListChecks, Package, TriangleAlert, Zap } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { TileId } from '../model/dashboard';

/**
 * Ikona listy roboczej — **jedno miejsce dla całego produktu**.
 *
 * ⚠ Do 2026-08-06 były dwa: pulpit rysował emoji (`✓ ⚡ 💤 📦 ⚠ 🔔 →`), a menu powłoki
 * ikony `lucide`. Komentarz przy tamtej tablicy twierdził „te same znaki co w menu" —
 * i **przestał być prawdą** w dniu, w którym menu dostało prawdziwe ikony. Dokładnie
 * ta klasa rozjazdu, której nikt nie zgłasza jako błędu: dwa widoki tej samej listy
 * po prostu wyglądają na dwie różne rzeczy.
 *
 * ⭐ Dlatego ikona należy do LISTY, nie do widoku. `AppShell` bierze ją stąd dla pozycji
 * mających kafel i deklaruje własną tylko tam, gdzie kafla nie ma (Constellation,
 * Kampanie, Import, Obciążenie zespołu).
 *
 * ⚠ Plik stoi w `components/`, nie w `model/`: `model` jest czystą logiką bez Reacta,
 * a to są komponenty ikon.
 */
export const TILE_ICONS: Record<TileId, LucideIcon> = {
  hanging: ListChecks,
  fired: Flame,
  dormant: Hourglass,
  iteration: Package,
  draugr: TriangleAlert,
  notices: Inbox,
  launched: Zap,
};
